import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Dialog, DialogContent } from '@mui/material';
import { AppDialogTitle, AppInput, DialogButtons } from 'components/common';
import { t } from 'i18next';
import React, { FC } from 'react';
import { useForm } from 'react-hook-form';
import { TKeys } from 'utils/enums';
import { contractSchema } from './login.schema';
import { getMessageText } from 'utils/helpers';

type Props = DialogProps<ContractCode>;

const ContractCode: FC<Props> = (props: Props) => {
    const { open, onClose, onSubmit } = props;

    const {
        handleSubmit,
        register,
        setValue,
        formState: { errors },
    } = useForm<ContractCode>({
        resolver: yupResolver(contractSchema(t)),
        defaultValues: {
            contract_code: '',
            authority_code: '',
        },
        shouldUnregister: true,
    });

    const handleFormSubmit = async (values: ContractCode) => {
        onSubmit && onSubmit(values);
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={(_, reason) => {
                if (reason === 'backdropClick') return;
                onClose();
            }}
            disableEscapeKeyDown
            autoFocus
            maxWidth="sm"
            fullWidth>
            <AppDialogTitle title={t(TKeys.LBL010008)} />

            <form onSubmit={handleSubmit(handleFormSubmit)} noValidate>
                <DialogContent>
                    <AppInput
                        register={register}
                        name={'contract_code'}
                        setValue={setValue}
                        error={!!errors.contract_code}
                        helperText={errors.contract_code?.message}
                        required
                        label={t(TKeys.LBL010009)}
                        placeHolder={getMessageText(t(TKeys.MSE00001), t(TKeys.LBL010009))}
                    />
                    <Box sx={{ height: 10 }} />
                    <AppInput
                        register={register}
                        setValue={setValue}
                        name={'authority_code'}
                        error={!!errors.authority_code}
                        helperText={errors.authority_code?.message}
                        required
                        placeHolder={getMessageText(t(TKeys.MSE00001), t(TKeys.LBL010011))}
                        label={t(TKeys.LBL010011)}
                    />
                </DialogContent>

                <DialogButtons
                    onClose={() => onClose()}
                    cancelLabel={t(TKeys.BTN000016)}
                    submitLabel={t(TKeys.BTN000017)}
                />
            </form>
        </Dialog>
    );
};

export default ContractCode;
